import { render, staticRenderFns } from "./PlanRate.vue?vue&type=template&id=decf1cfe&scoped=true&"
import script from "./PlanRate.vue?vue&type=script&lang=js&"
export * from "./PlanRate.vue?vue&type=script&lang=js&"
import style0 from "./PlanRate.vue?vue&type=style&index=0&id=decf1cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decf1cfe",
  null
  
)

export default component.exports